export const updateElements = async (
  selectors: string | string[],
  sectionId?: string,
) => {
  try {
    const response = await fetch(
      sectionId ? `?sections=${sectionId}` : location.href,
    );
    const html = sectionId
      ? (await response.json())[sectionId]
      : await response.text();
    const newdoc = new DOMParser().parseFromString(html, "text/html");

    if (typeof selectors === "string") {
      selectors = [selectors];
    }

    for (const selector of selectors) {
      const elements = document.querySelectorAll(selector);
      const newElements = newdoc.querySelectorAll(selector);

      if (elements.length !== newElements.length) {
        throw new Error("Elements count mismatch for: " + selector);
      }

      elements.forEach((element, index) => {
        const newElement = newElements[index];

        if (element && newElement) {
          element.outerHTML = newElement.outerHTML;
        }
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error({ error });
  }
};
